import React from 'react'

import { Portlet, Row, Col, Button, Form } from '_zari/core'

import { ZariContext } from '_zari/context'

import * as FacturacionService from 'services/facturacion.service'

import { MesContabilidadSelect, SelectSede } from 'sharedComponents/select'

import { DownloadAxiosFile } from 'utils'

const FormatoCruceComprasContabilidad = () => {
  const __zariContext = React.useContext(ZariContext)

  const [mesSeleccionado, setMesSeleccionado] = React.useState()
  const [sedeSeleccionada2, setSedeSeleccionada2] = React.useState([])

  const clickDescargarCruceVentasKardex = React.useCallback(() => {
    __zariContext.loader.open('Descargando Reporte Cruce Ventas Kardex...')
    FacturacionService.descargarFormatoCruceVentasKardex({
      mesSeleccionado,
      sedeSeleccionada2
    })
      .then(({ data, headers }) => {
        DownloadAxiosFile.downloadAsBlob(data, headers)
      })
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
      .finally(() => {
        __zariContext.loader.close()
      })
  }, [__zariContext, mesSeleccionado, sedeSeleccionada2])

  return (
    <Portlet>
      <Portlet.Header title='Reporte Cruce Ventas - Kardex' />
      <Portlet.Body>
        <Row>
          <Col md={12}>
            <Form.Group>
              <Form.Label text='MES' htmlFor='select-mes' md={2} alignRightAt='md' />
              <Col md={10}>
                <MesContabilidadSelect
                  name='select-mesContabilidad-cruce2'
                  id='select-mesContabilidad-cruce2'
                  value={mesSeleccionado}
                  onChange={e => setMesSeleccionado(e.target.value)}
                />
              </Col>
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <Form.Group>
              <Form.Label text='ESTABLECIMIENTO' htmlFor='select-sede-cruce' md={2} alignRightAt='md' />
              <Col md={10}>
                <SelectSede
                  name='select-sede-cruce2'
                  id='select-sede-cruce2'
                  value={sedeSeleccionada2}
                  onChange={e => setSedeSeleccionada2(e.target.value)}
                />
              </Col>
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col md={12} className='text-right'>
            <Button onClick={clickDescargarCruceVentasKardex}>Descargar Reporte</Button>
          </Col>
        </Row>
      </Portlet.Body>
    </Portlet>
  )
}

export default React.memo(FormatoCruceComprasContabilidad)
